import { Loader } from '@googlemaps/js-api-loader';
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from 'core/config/google-maps';

let loadPromise: Promise<typeof google> | null = null;

export function loadGoogleMaps(): Promise<typeof google> {
  if (!GOOGLE_MAPS_API_KEY) {
    return Promise.reject(new Error('VITE_GOOGLE_MAPS_API_KEY is not set'));
  }
  if (!loadPromise) {
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      libraries: [...GOOGLE_MAPS_LIBRARIES],
    });
    loadPromise = loader.load();
  }
  return loadPromise;
}
